const TipoCampanha = Object.freeze({
  QRCODE: 'QR Code',
  NOVOS_CADASTROS: 'Novos Cadastros'
});

export default TipoCampanha;
